import { jsx as _jsx } from "react/jsx-runtime";
const MiniSpinner = ({ color }) => {
    return _jsx("div", { role: "progressbar", className: color === 'white' ? 'mini-spinner-white' : 'mini-spinner' });
};
export default MiniSpinner;
